'use strict';

import FormController from 'app/controllers/form';
import raven from 'raven';

class OperationTypeController extends FormController {
  /* @ngInject */
  constructor(
    OperationTypesService,
    StatesTemplatesService,
    $scope,
    $mdToast,
    $mdDialog,
    $location,
    $state
  ) {
    let operationType = $scope.$parent.$resolve.operationType;
    super(
      operationType,
      'Tipo de operacion',
      OperationTypesService,
      null,
      'operation-types'
    );

    Object.assign(this, {
      OperationTypesService,
      StatesTemplatesService,
      $mdToast,
      $mdDialog,
      $location,
      $state
    });
    this.btnEnabled = true;
  }

  $onInit() {
    super.$onInit();
    this.statesTemplates = this.model.statesTemplates || [];
  }

  queryStatesTemplateSearch(text) {
    return this.StatesTemplatesService.find({
      filter: {
        where: {
          name: {
            regexp: `^.*${text}.*$/i`
          }
        }
      }
    });
  }

  addStatesTemplate(item) {
    if (!item) {
      return Promise.resolve();
    }
    return Promise.resolve()
      .then(() => {
        if (!this.model.id) {
          if (this.form.$valid) {
            this.showSpin = true;
            return this.model.$save();
          } else {
            return this.simpleError('El modelo de tramite necesita un nombre');
          }
        }
      })
      .then(() => {
        this.showSpin = false;
        this.updateLocation();
        return this.OperationTypesService.addStatesTemplate(this.model, item);
      })
      .then(
        () => {
          this.newStatesTemplate = null;
          this.statesTemplates.push(item);
          this.simpleSuccess();
        },
        err => {
          raven.captureException(err);
          this.simpleError();
        }
      );
  }

  removeStatesTemplate(item) {
    this.OperationTypesService.removeStatesTemplate(this.model, item).then(
      () => {
        const index = this.statesTemplates.findIndex(it => it.id == item.id);
        if (index > -1) {
          this.statesTemplates.splice(index, 1);
        }
        this.simpleSuccess();
      },
      err => {
        raven.captureException(err);
        this.simpleError();
      }
    );
  }
}

export default OperationTypeController;
